import { render, staticRenderFns } from "./ReportTextData.vue?vue&type=template&id=04440e56&scoped=true&"
import script from "./ReportTextData.vue?vue&type=script&lang=js&"
export * from "./ReportTextData.vue?vue&type=script&lang=js&"
import style0 from "./ReportTextData.vue?vue&type=style&index=0&id=04440e56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04440e56",
  null
  
)

export default component.exports